import { createActionCreator } from '@pressreader/appstore';

import { MODULE_NAME } from '../../constants';
import { Comment } from '../../types/comment';
import { AnyCommentAttachment } from '../../types/comment.attachment';

const prefix = `${MODULE_NAME}/attachments/`;

export const addImageAction = createActionCreator<{ draftId: string; comment?: Comment }>(`${prefix}add-image`);
export const addVideoAction = createActionCreator<{ draftId: string; comment?: Comment }>(`${prefix}add-video`);

export const attachmentUploadStarted = createActionCreator<{ draftId: string; attachment: AnyCommentAttachment }>(
    `${prefix}attachment-upload-started`,
);
export const attachmentUploadDone = createActionCreator<{ draftId: string; attachment: AnyCommentAttachment }>(`${prefix}attachment-upload-done`);
export const attachmentUploadFailed = createActionCreator<{ draftId: string; attachment: AnyCommentAttachment }>(`${prefix}attachment-upload-failed`);

export const attachmentDeleted = createActionCreator<{ draftId: string; id: string }>(`${prefix}attachment-deleted`);
